import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home.vue'
import store from '../store/index'

Vue.use(VueRouter)

const routes = [{
    path: '/chart',
    name: 'home',
    component: HomeView
},
{
    path: "aggregation",
    component: () => import('../views/aggregation.vue'),
    children:
        [
            {
                path: '//',
                name: 'list',
                component: () =>
                    import('../views/list.vue')
            }, {
                path: '/web',
                name: 'web',
                component: () =>
                    import('../views/webView.vue')
            }, {
                path: '/scheme/:step',
                name: 'scheme',
                component: () =>
                    import('../views/module/scheme/index.vue')
            },
            {
                path: "/constant",
                name: 'constant',
                component: () =>
                    import('../views/checkConst.vue')
            },
            // {
            //     path: '/brief',
            //     name: 'brief',
            //     component: () =>
            //         import('../views/brief/index.vue')
            // }
        ]
},
{
    path: "/repository",
    name: 'repository',
    component: () =>
        import('../views/repository/index.vue')
},
{
    path: "/repository/list",
    name: 'repositoryList',
    component: () =>
        import('../views/repository/list.vue')
},
{
    path: "/repository/detail",
    name: 'repositoryDetail',
    component: () =>
        import('../views/repository/detail.vue')
},
{
    path: '/login',
    name: 'login',
    component: () =>
        import('../views/login.vue')
}]


const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes
})

// BAD
router.beforeEach(async (to, from, next) => {
    await store.state.Login
    if (to.name !== 'login' && !Object.keys(store.state.user).length)
        next({ name: 'login' })
    else
        next()
})

export default router